/**
 * Calculation engine version.
 *
 * Stamped onto every persisted document. Combined with the rounding policy
 * id it answers, for any document ever issued: which rules produced these
 * numbers, and can they be reproduced exactly?
 *
 * A 2026 invoice must render identically in 2036. Changing a rounding rule
 * bumps this string; it never silently re-prices historical documents.
 */
import { ROUNDING_POLICY } from './roundingPolicy';

export const CALC_VERSION = `calc@2.0.0+${ROUNDING_POLICY.id}` as const;
